var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-wrapper" },
    [
      _c("el-tree", {
        ref: "treeRef",
        attrs: {
          data: _vm.treeData,
          "show-checkbox": "",
          "node-key": "prop",
          "default-expand-all": "",
          "default-checked-keys": _vm.selectedProp,
          draggable: "",
          "allow-drop": _vm.allowDrop,
          "allow-drag": _vm.allowDrag,
          props: _vm.defaultProps,
        },
        on: { "node-drag-end": _vm.handleDragEnd, check: _vm.handleChange },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var node = ref.node
              return _c("span", { staticClass: "custom-tree-node" }, [
                _c("span", [_vm._v(_vm._s(node.label))]),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }